export default __webpack_public_path__ + "static/media/stamp-large.8692fbf8.png";